import React from 'react';

export const TermsCanvas: React.FC = () => {
    return (
        <div>
            Terms & Policy ...
        </div>
    );
};

